import React, { useState } from "react";
import "./LandDetailModel.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
function LandDetailModel() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <div>
      <div>
        <Button variant="primary" onClick={handleShow}>
          BUY NOW
        </Button>

        <Modal
          show={show}
          onHide={handleClose}
          animation={false}
          centered
          className=" land-detail-modal"
        >
          <Modal.Header className="modal-header" closeButton>
            <Modal.Title className="modal-title">
              <h2 className="body-medium ">Connect your wallet</h2>
              <p>
                If you don't have a wallet, you can select a provider and create
                one now.
              </p>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="modal-body">
            <div className="main">
              <p className="setting">
                <img
                  src="\assets\images\LanDetail-Model-images\MetaMask.png"
                  alt=""
                />
                MetaMask
              </p>
              <p className="setting">
                <img
                  src="\assets\images\LanDetail-Model-images\CoinBaseWallet.png"
                  alt=""
                />
                Coinbase Wallet
              </p>
              <p className="setting">
                <img
                  src="\assets\images\LanDetail-Model-images\WalletConnect.png"
                  alt=""
                />
                Wallet Connect
              </p>
              <p className="setting">
                <img
                  src="\assets\images\LanDetail-Model-images\Ledger.png"
                  alt=""
                />
                Ledger
              </p>
              <p className="setting">
                <img
                  src="\assets\images\LanDetail-Model-images\Phantom.png"
                  alt=""
                />
                Phantom
              </p>
              <p className="setting">
                <img
                  src="\assets\images\LanDetail-Model-images\Glow.png"
                  alt=""
                />
                Glow
              </p>
              <p className="setting">
                <img
                  src="\assets\images\LanDetail-Model-images\OperaTouch.png"
                  alt=""
                />
                OperaTouch
              </p>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
}

export default LandDetailModel;
